// extracted by mini-css-extract-plugin
export default {"wrap":"EmptyState_wrap__fQN4X","message":"EmptyState_message__5v-0H","hint":"EmptyState_hint__rvS3g","action":"EmptyState_action__uhAH8"};